const $ = jQuery.noConflict();

'use strict';
const LoadMoreProductsList = {
	$loadMoreButton: $('.js-pagination-products-list'),
	$loadMoreCounter: $('.js-products-list-more-counter'),
	page: 1,

	init: function() {
		if (this.$loadMoreButton.length === 0) return;
		this.bindEvents();
	},

	bindEvents: function() {
		const _this = this;
		this.$loadMoreButton.on('click', function() {
			const nextPageItems = $('.js-products-list-page[data-page="' + _this.page + '"]');
			if (nextPageItems.length > 0) {
				nextPageItems.removeClass('hidden-element');
				_this.page++;

				const nextPage = $('.js-products-list-page[data-page="' + _this.page + '"]');
				if (nextPage.length === 0) {
					_this.$loadMoreButton.remove();
				} else {
					const itemsCount = nextPage.data('items-count');
					if (itemsCount) {
						_this.$loadMoreCounter.text(itemsCount + ' More');
					}
				}
			}
		});
	},
};

export default LoadMoreProductsList;
